import { render, staticRenderFns } from "./StepMockBankCredentials.vue?vue&type=template&id=13673271&scoped=true"
import script from "./StepMockBankCredentials.vue?vue&type=script&lang=js"
export * from "./StepMockBankCredentials.vue?vue&type=script&lang=js"
import style0 from "./StepMockBankCredentials.vue?vue&type=style&index=0&id=13673271&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13673271",
  null
  
)

export default component.exports